import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Store } from '@ngrx/store';
import 'rxjs/add/operator/switchMap';
import { RequestUtils } from '../shared/utils/request';
import { getAuthTokenSelector } from '../shared/auth/auth.reducer';
import 'rxjs/add/operator/combineLatest';
import { getUserDetailsSelector } from '../shared/user/user.reducer';
import { accountFromLocalStorage } from '../../../old-crazy-web-frontend/src/app/utils/account-from-localstorage';
var AuthorizedHeader = /** @class */ (function () {
    function AuthorizedHeader(store, requestUtils) {
        this.store = store;
        this.requestUtils = requestUtils;
    }
    AuthorizedHeader.prototype.intercept = function (req, next) {
        var _this = this;
        if (req.headers.has('Authorization') && req.headers.has('account')) {
            return next.handle(req);
        }
        else {
            return this.store
                .select(getAuthTokenSelector)
                .withLatestFrom(this.store.select(getUserDetailsSelector))
                .take(1)
                .switchMap(function (_a) {
                var token = _a[0], user = _a[1];
                if (token && _this.requestUtils.isOurDomain(req)) {
                    req = req.clone({
                        setHeaders: {
                            Authorization: "Bearer " + token
                        }
                    });
                    // TODO: find a better solution
                    //  The following code fixes the issue that for two calls:
                    // - account/msisdn-fully-configured
                    // - finance/subscription/payment
                    // The root cause is that UserAddAction does not change the account (domain) in the store
                    // fast enough to get it here
                    var d = accountFromLocalStorage();
                    var domainFromLocalStorage = d ? d.replace(/\"/g, '') : null;
                    if (user.domain || domainFromLocalStorage) {
                        req = req.clone({
                            setHeaders: {
                                account: user.domain || domainFromLocalStorage
                            }
                        });
                    }
                }
                return next.handle(req);
            });
        }
    };
    return AuthorizedHeader;
}());
export { AuthorizedHeader };
export var AuthorizedHeaderInterceptor = {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthorizedHeader,
    multi: true
};
